import type { RefObject } from 'react'
import { useEffect } from 'react'

type AnyEvent = MouseEvent | TouchEvent

const useOnClickOutside = (ref: RefObject<HTMLElement>, callback: (e: AnyEvent) => void) => {
  useEffect(() => {
    const handleClickOutside = (e: AnyEvent) => {
      if (!ref.current?.contains(e.target as Node)) {
        callback(e)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    document.addEventListener('touchstart', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
      document.removeEventListener('touchstart', handleClickOutside)
    }
  }, [callback, ref])
}

export default useOnClickOutside
